export const returnLinks = [
  '/stock-summary/reports/',
  '/stock/detail/report/',
  '/stock/ledger/report/',
  '/reports/',
  '/ledger/reports/',
  '/ledger-details/reports/',
  '/sales/edit/',
  '/sales/create/',
  '/sales/order/create/',
  '/sales/order/edit/',
  '/sundry-creditors/reports/',
  '/sundry-ledger-details/reports/',
  '/debtors-ledger-details/reports/',
  '/cash-bank-ledger-details/reports/',
  '/karigar/ledger-details/reports/',
  '/sales/return/create/',
];
